import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useLocation } from "@reach/router"
import App from "../components/App"
import Modal from "../components/Modal"
import PageModal from "../components/PageModal"
import PageModalBody from "../components/PageModalBody"
import PageTitle from "../components/PageTitle"
import { getRoute, navigate } from "../helpers/routing"
import { resetLoginError } from "../state/modules/login"
import FrontPageMeta from "../components/FrontPageMeta"
import LoginPageContent from "../components/LoginPageContent"

const LoginPage = ({ isAuthenticated, resetError }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  const { state } = useLocation()

  useEffect(() => {
    if (isAuthenticated) {
      if (state && state.returnTo) {
        navigate(state.returnTo, language)
      } else {
        navigate("/", language)
      }
    }
  }, [isAuthenticated, language, state])

  return (
    <App>
      <Modal>
        <PageModal size="md">
          <PageTitle closeTo={getRoute("/", language)} onClose={resetError}>
            {t("##.Auth.SignIn")}
          </PageTitle>
          <PageModalBody>
            <LoginPageContent />
          </PageModalBody>
        </PageModal>
      </Modal>
    </App>
  )
}

export const Head = ({ pageContext }) => (
  <FrontPageMeta language={pageContext.language} />
)

const mapStateToProps = state => {
  return {
    isAuthenticated: state.login.isAuthenticated,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetError: () => {
      dispatch(resetLoginError())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)
